var _a;
var _b = require('../turtle/tokens'), turtleTokenTypes = _b.turtleTokenTypes, turtleTokenMap = _b.turtleTokenMap;
var sparqlTokenMap = require('../sparql/tokens').sparqlTokenMap;
import { createToken } from 'chevrotain';
import { CATCH_ALL_AT_LEAST_ONE } from '../helpers/matchers';
var LexerMode;
(function (LexerMode) {
    LexerMode["TURTLE"] = "turtle";
    LexerMode["IFCLAUSE"] = "ifclause";
    LexerMode["THENCLAUSE"] = "thenclause";
})(LexerMode || (LexerMode = {}));
var Rule = createToken({
    name: 'Rule',
    pattern: /rule/i,
});
var If = createToken({
    name: 'If',
    pattern: /if/i,
    push_mode: LexerMode.IFCLAUSE,
});
var Then = createToken({
    name: 'Then',
    pattern: /then/i,
    push_mode: LexerMode.THENCLAUSE,
});
var EndThen = createToken({
    name: 'EndThen',
    pattern: '}',
    pop_mode: true,
});
// NOTE: Not a SPARQL GroupGraphPattern. Rather, a placeholder for one. We have
// to let the SRS parser create this token, then replace with a token returned
// by the SPARQL sub-parser.
var GroupGraphPattern = createToken({
    name: 'GroupGraphPattern',
    pattern: function (text, startOffset) {
        if (startOffset === void 0) { startOffset = 0; }
        // Capture a single brace and then anything up to its closing brace.
        if (text[startOffset] !== '{') {
            return null;
        }
        var unclosedBraceCount = 1;
        var cursor;
        for (cursor = startOffset + 1; cursor < text.length && unclosedBraceCount > 0; cursor++) {
            if (text[cursor] === '{') {
                unclosedBraceCount++;
            }
            else if (text[cursor] === '}') {
                unclosedBraceCount--;
            }
        }
        if (unclosedBraceCount > 0) {
            return null;
        }
        return CATCH_ALL_AT_LEAST_ONE.exec(text.slice(startOffset, cursor));
    },
    line_breaks: true,
    pop_mode: true,
});
// NOTE: Not a SPARQL TriplesBlock. Rather, a placeholder for one. We have
// to let the SRS parser create this token, then replace with a token returned
// by the SPARQL sub-parser.
var TriplesBlock = createToken({
    name: 'TriplesBlock',
    pattern: /[^{}]+/,
    line_breaks: true,
});
var indexOfIriRef = turtleTokenTypes.indexOf(turtleTokenMap.IRIREF);
export var multiModeLexerDefinition = {
    modes: (_a = {},
        _a[LexerMode.TURTLE] = turtleTokenTypes.slice(0, indexOfIriRef + 1).concat([
            Rule,
            If,
            Then
        ], turtleTokenTypes.slice(indexOfIriRef + 1)),
        _a[LexerMode.IFCLAUSE] = [turtleTokenMap.WhiteSpace, GroupGraphPattern],
        _a[LexerMode.THENCLAUSE] = [
            turtleTokenMap.WhiteSpace,
            sparqlTokenMap.LCurly,
            EndThen,
            TriplesBlock,
        ],
        _a),
    defaultMode: LexerMode.TURTLE,
};
export var srsTokenMap = {
    Rule: Rule,
    If: If,
    Then: Then,
    EndThen: EndThen,
    GroupGraphPattern: GroupGraphPattern,
    TriplesBlock: TriplesBlock,
};
export var srsTokenTypes = [
    Rule,
    If,
    Then,
    EndThen,
    sparqlTokenMap.LCurly
].concat(turtleTokenTypes, [
    GroupGraphPattern,
    TriplesBlock,
]);
